// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vTIU","rightAdornment":"Header_rightAdornment__7eyW-"};